/**
 * Class used to attach metadata after receiving a Push event.
 */
export class PushEventMetadata {
  constructor() {
    this.notifySubscribers = true;
  }

  private notifySubscribers: boolean;

  get shouldNotifySubscribers() {
    return this.notifySubscribers;
  }

  preventNotifySubscribers() {
    this.notifySubscribers = false;
  }
}
